var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExist > 0)?_c('feather-icon',{staticClass:"ml-2",attrs:{"color":"success","icon":"MessageSquareIcon","svg-classes":"h-5 w-5 text-success"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }